<template>
	<div class="modal fade" ref="modal" data-backdrop="static">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">Resutados do exames</h4>
				</div>
				<div class="modal-body no-padding">
					<header-exams :sol="sol" :exams="exams" />
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-4">
								<grid-exams
									:exams="exams"
									@selectExam="fxSaveData"
									:sel="examSelected"
								/>
							</div>
							<div class="col-sm-8">
								<form-lines
									v-if="examSelected != null"
									:lines="dataExamSel"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button
						type="button"
						:disabled="blockButton != 0"
						class="btn btn-default pull-left"
						data-dismiss="modal"
					>
						<i class="fa fa-close"></i> Cancelar
					</button>

					<button
						v-if="blockButton == 0"
						class="btn btn-primary"
						@click="saveResults"
					>
						<i class="fa fa-save"></i> Salvar
					</button>
					<button v-else class="btn btn-primary" disabled>
						<i class="fa fa-spin fa-spinner"></i> Salvando...
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import headerExams from './header.vue';
	import gridExams from './gridExams.vue';
	import formLines from './formLines.vue';
	import toastr from 'toastr';

	import WBS from 'js/http';

	export default {
		name: 'mdExams',
		components: { headerExams, gridExams, formLines },
		data() {
			return {
				sol: null,
				exams: [],
				examSelected: null,
				blockButton: 0,
			};
		},
		computed: {
			dataExamSel() {
				return this.exams.find((item) => item.cod == this.examSelected);
			},
		},
		watch: {
			blockButton: function (val, old) {
				if (val == 0 && old == 1) {
					toastr.success('Exames salvos com sucesso!');
				}
			},
		},
		methods: {
			saveResults() {
				this.exams.forEach((item) => {
					if (item.status == 1) {
						this.blockButton++;
						WBS.send('private-save-sd2000Results', item, (resp) => {
							this.blockButton--;
						});
					}
				});
			},
			fxSaveData(data) {
				this.examSelected = data;
			},
			open(data) {
				this.sol = data;
				this.exams = [];
				$(this.$refs.modal).modal('show');
				WBS.send('private-read-examsSD2000', data.cod, (resp) => {
					if (resp.status == 'success') {
						this.exams = resp.data;
						this.examSelected = resp.data[0].cod;
					}
				});
			},
		},
		destroyed() {
			$(this.$refs.modal).modal('hide');
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/mdExams/index.vue